<template>
  <div class="container container-box">
    <div class="list-header">
      <div class="header-line"></div>
      <div class="header-title">{{$t('my.nav.doc')}}</div>
    </div>
    <div class="common-list"
         v-loading.fullscreen="listLoading">
      <NoData v-if="list.length<=0 && !upItem['filename']"
              v-bind:title="$t('doc.nodata')"></NoData>
      <DocItem
        ref="doccanvas"
        v-bind:canvas = "true"
        v-if="upItem['filename']"
        class="common-item"
        v-bind:o="upItem">
      </DocItem>
      <DocItem v-for="(item,index) in list"
           class="common-item"
           :key="index" 
           @refDelItem="deleItem"
           @payItem = "payItem"
           v-bind:isChinese='isChinese'
           v-bind:o="item">
      </DocItem>
    </div>
    <div class="footer-bottom-button"><UpFileButton @updata="updata"></UpFileButton></div>
    <div class="footer-bottom-heights"></div>
    <PayVipComponent ref="payvip"></PayVipComponent>
    <div v-infinite-scroll="loadMore"
         infinite-scroll-disabled="busy"
         infinite-scroll-distance="10"></div>
  </div>
</template>

<script>
import { getDocRecord ,delDocItem,USER_INFO,payDoc} from '@/api/user'
import { formatTime , whatLang} from '@/utils/index'
import{isPhone} from '@/api/public'
import {getPreView,getBacking,handleOpen} from '@/api/doc'
import config from '../config/config'
import jump from 'jump.js'
import NoData from '../components/NoData.vue'
import DocItem from '../components/DocItem.vue';
import UpFileButton from '../components/UpFileButton.vue';
import PayVipComponent  from '../components/PayVipComponent.vue';

const wordlogo = require("../assets/doc-icon.png");
const pdflogo = require("../assets/pdf-icon.png");
let cDocId = "";
let docType = "word";

export default {
  components:{NoData,DocItem,UpFileButton,PayVipComponent},
  data() {
    return {
      list: [],
      listLoading: true,
      centerDialogVisible: false,
      group: 3,
      page:1,
      page_size: 10,
      busy: true,
      upItem:{},
      isChinese: whatLang() !='zh',
      userId : '',
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData:function(flag) {
      this.listLoading = true;
      getDocRecord({
        page: this.page,
        page_size: this.page_size
      }).then(response => {
        this.listLoading = false
        var list = response.doc_translateds || [];
        for (let i = 0, l = list.length; i < l; i++) {
          var item = list[i]
          if (item.file_type == "pdf") {
            list[i].doc_img = pdflogo
          } else {
            list[i].doc_img = wordlogo
          }

          if(item.status == 1 && item.preview_status == 2){
            list[i].status_text = this.$t('global.status.preview');
          }else{
            list[i].status_text = this.$t('global.status.translation');
          }
          if(item.status == 2 ){
            list[i].status_text = this.$t('global.status.done');
          }
          if(item.status == 3 ){
            list[i].status_text =this.$t('global.status.failed');
          }
          if(item.status == 4 ){
            list[i].status_text = this.$t('global.status.done');
          }

          list[i].created_at = formatTime(list[i].created_at)
          list[i].read_link = "/fanyi/pdf_viewer.html?doc_id=" + list[i].id
          if (list[i].trans_type == "zh2en") {
            list[i].trans_type = this.$t('global.lang.zh')+" → "+this.$t('global.lang.en');
          } else if (list[i].trans_type == "en2zh") {
            list[i].trans_type =  this.$t('global.lang.en')+" → "+this.$t('global.lang.zh');
          }else if(list[i].trans_type == "zh2ja"){
            list[i].trans_type =  this.$t('global.lang.zh')+" → "+this.$t('global.lang.ja');

          }else if(list[i].trans_type == "ja2zh"){
            list[i].trans_type =  this.$t('global.lang.ja')+" → "+this.$t('global.lang.zh');
          }
//          list[i].site = new URL(list[i].link).host
      }
        if (flag) {
          // 滚动加载数据
          this.list = this.list.concat(list)
          jump(500, {
            duration: 400
          })
          if (list.length == 0) {
            this.busy = true;
          } else{
            this.busy = false;
          }
        } else {
          // 首次加载数据
          this.list = list || [];
          this.busy = false;
        }
      }, (err) => {
        this.listLoading = false
      })
    },
    handleOpen:function(item){
      handleOpen(item);
    },
    loadMore: function(){
      this.busy = true;
      this.page ++;
      this.fetchData(true);
    },
    init:function(){
        this.page = 1;
        this.busy = true;
        this.fetchData(true);
    },
    deleItem:function(e){
      const id = e.id;
      const name = e.filename;
      this.$confirm(`${this.$t('doc.delete')}${name}?`, this.$t('doc.tips'), {
        confirmButtonText: this.$t('doc.sure'),
        cancelButtonText: this.$t('doc.cancel'),
        type: 'warning'
      }).then(() => {
        delDocItem(id).then(res=>{
          if(res.rc == 0 ){
            for(let i = 0 ; i < this.list.length ; i++){
              if(id == this.list[i].id){
                this.list.splice(i,1);
                this.$message({
                  type: 'success',
                  message: this.$t('doc.deleteSuccess')+'!'
                });
                if(this.list.length===0){
                  this.init();
                }
                return;
              }
            }
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('doc.deletefailed')
        });
      });
    },
    updata: function(e){
      if(e.status === 'ok'){
        this.page = 1;
        this.fetchData();
        this.upItem = {};
      }else if(e.status ==="progress"){
        this.upItem = {
          doc_size: e.file._size,
          file_type: e.file._type,
          filename: e.file.name,
          preview_progress: 0,
          preview_status: 1,
          progress: e.progress,
          status_text:'上传中',
          status: 1,
          trans_type: e.file._trans_type,
          doc_img:e.file.doc_img
        };
        if (this.$refs.doccanvas){
          this.$refs.doccanvas.outUseCanvas(e.progress);
        }
      }
    },
    payItem:function(item){
      this.userId = USER_INFO()._id;
      getPreView(this.userId,item.doc_id).then(res=>{
        if(res.rc == 0){
          // res.is_allow = false;

          this.$refs.payvip.show({
              item:item,
              data:res,
              userId:this.userId
          });

          // if(res.is_allow == true && res.pay_detail){
          //   this.handleOpen(item);
          // }else{
          //   this.$refs.payvip.show({
          //     item:item,
          //     data:res,
          //     userId:this.userId
          //   });
          // }
        }
      })
    },
  }
}
</script>
<style scoped>
  @import "../css/list-item.scss";
  .common-item{
    border-bottom: 1px solid #BFBFBF;
  }
  .common-item:nth-last-child(){
    border-bottom: none;
  }
   .footer-bottom-heights,.footer-bottom-button {
     display: none;
   }
  @media (max-width: 650px){
    .footer-bottom-button,.footer-bottom-heights{
      display: block;
    }
    .footer-bottom-heights {
       height: 50px;
       width: 100%
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/doc1.vue